import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (disabledClear) => ({
  justifyContent: disabledClear ? 'space-between' : 'initial',
  width: disabledClear ? '100%' : 'initial',
});
